// Pure summary builder for Library bulk actions (DECIDE-LIBRARY-001).
//
// Bug: BacklogScreen.runBulk caught per-item failures as `catch { fail += 1 }`,
// discarding WHICH item failed and WHY; the user saw only an aggregate
// "(N failed)" with no way to tell what to retry. This builder surfaces the
// failed items by title (+ the reason when there is a single failure), so the
// notice is actionable. Pure + injectable → gated without rendering BacklogScreen.

export interface BulkFailure {
  id: string;
  title?: string;
  error?: string;
}

export function buildBulkSummary(
  label: string,
  okCount: number,
  failures: readonly BulkFailure[]
): string {
  const okPart = `${label} ${okCount} item${okCount === 1 ? "" : "s"}`;
  if (failures.length === 0) return okPart;

  const names = failures
    .slice(0, 3)
    .map((f) => (f.title && f.title.trim() ? f.title.trim() : f.id));
  const more = failures.length > 3 ? ` +${failures.length - 3} more` : "";
  const reason =
    failures.length === 1 && failures[0].error ? ` — ${failures[0].error}` : "";

  return `${okPart} · couldn't add ${failures.length}: ${names.join(", ")}${more}${reason}`;
}
